import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import InstantApprovalView from '../views/InstantApprovalView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: { sidebar: false }
    },
    {
      path: '/instantapproval',
      name: 'instant approval',
      component: InstantApprovalView,
      meta: { sidebar: true },
    }
  ]
})

export default router
